import React from 'react'
import {
  Layout,
  Showcase,
  Header,
  SectionTitle,
  Intro,
} from '../../../../components'

import './style.scss'
import data from './data.json'

export default () => {
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
        exclusive={true}
      />
      <Layout
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
      >
        <Intro class="intro no-padding">
          <p>
            A list groups related content together and arranges it vertically
            for easier readability. List classes are designed for{' '}
            <span class="inline__code">{'<ul>'}</span> or{' '}
            <span class="inline__code">{'<ol>'}</span> elements and their{' '}
            <span class="inline__code">{'<li>'}</span> children.
          </p>
        </Intro>

        <Showcase
          site={data.site}
          title="Ordered List"
          text="Pairing list items with numbers helps the user recognize that the order or total number of items is important."
          code={code.orderedList}
        >
          <ol class="c-ordered-list">
            <li class="c-ordered-list__item">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit.
            </li>
            <li class="c-ordered-list__item">
              Euismod nisi porta lorem mollis.
            </li>
            <li class="c-ordered-list__item">
              Neque volutpat ac tincidunt vitae semper.
            </li>
          </ol>
        </Showcase>
        <Showcase
          site={data.site}
          title="Unordered List"
          text="Pairing list items with bullets helps the user recognize that all content presented is of equal status or value."
          code={code.unorderedList}
        >
          <ul class="c-unordered-list">
            <li class="c-unordered-list__item">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit.
            </li>
            <li class="c-unordered-list__item">
              Euismod nisi porta lorem mollis.
            </li>
            <li class="c-unordered-list__item">
              Neque volutpat ac tincidunt vitae semper.
            </li>
          </ul>
        </Showcase>
        <Showcase
          site={data.site}
          title="Icon List"
          text="Pairing list items with icons makes the unordered content the primary focus in a layout."
          code={code.iconList}
        >
          <ul
            class="c-icon-list layout--thinner"
            arialabelledby="accountdetailslabel"
          >
            <li class="c-icon-list__item undefined">
              <span class="c-icon-list__icon">
                <i class="icon icon--stopwatch"></i>
              </span>
              <span class="c-icon-list__content">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
              </span>
            </li>
            <li class="c-icon-list__item undefined">
              <span class="c-icon-list__icon">
                <i class="icon icon--person"></i>
              </span>
              <span class="c-icon-list__content">
                Euismod nisi porta lorem mollis.
              </span>
            </li>
            <li class="c-icon-list__item list__item--less-space">
              <span class="c-icon-list__icon">
                <i class="icon icon--piggy-bank"></i>
              </span>
              <span class="c-icon-list__content">
                Neque volutpat ac tincidunt vitae semper.
              </span>
            </li>
          </ul>
        </Showcase>
        <SectionTitle>Design Environment</SectionTitle>
        <Showcase
          site={data.site}
          title=""
          text={
            <p>
              Use a <span class="inline__code">l-margin-horizontal--large</span>{' '}
              to create 24px of space between lists and any components before or
              after. Ordered and unordered lists have a{' '}
              <span class="inline__code">l-margin-left--medium</span> for a 16px
              left-side indentation.
            </p>
          }
          code={code.spaceAround}
        >
          <title class="c-label">Here is a list of what you'll need:</title>
          <ol class="c-ordered-list l-margin-vertical--large">
            <li class="c-ordered-list__item l-margin-left--medium">
              List Item
            </li>
            <li class="c-ordered-list__item l-margin-left--medium">
              List Item
            </li>
            <li class="c-ordered-list__item l-margin-left--medium">
              List Item
            </li>
          </ol>
          <p class="c-text-content">Now that you know what you'll need...</p>
        </Showcase>

        <Showcase
          site={data.site}
          title=""
          text={
            <p>
              Use at least a{' '}
              <span class="inline__code">l-margin-horizontal--medium</span> to
              create 16px of space between lists items. In icon lists, increase
              the margin between items to{' '}
              <span class="inline__code">l-margin-horizontal--large</span> for a
              24px.
            </p>
          }
          code={code.spaceBetween}
        >
          <ul class="c-unordered-list l-margin-vertical--large">
            <li class="c-unordered-list__item l-margin-left--medium l-margin-bottom--medium">
              List Item
            </li>
            <li class="c-unordered-list__item l-margin-left--medium l-margin-bottom--medium">
              List Item
            </li>
            <li class="c-unordered-list__item l-margin-left--medium l-margin-bottom--medium">
              List Item
            </li>
          </ul>
        </Showcase>
      </Layout>
    </>
  )
}

export const code = {
  orderedList: `<ol class="c-ordered-list">
    <li class="c-ordered-list__item">List Item</li>
    <li class="c-ordered-list__item">List Item</li>
    <li class="c-ordered-list__item">List Item</li>
</ol>
`,
  unorderedList: `<ul class="c-unordered-list">
    <li class="c-unordered-list__item">List Item</li>
    <li class="c-unordered-list__item">List Item</li>
    <li class="c-unordered-list__item">List Item</li>
</ul>`,
  iconList: `<ul class="c-icon-list" arialabelledby="accountdetailslabel">
    <li class="c-icon-list__item">
      <span class="c-icon-list__icon">
        <i class="icon icon--stopwatch"></i>
      </span>
        <span class="c-icon-list__content">List Item</span>
    </li>
    <li class="c-icon-list__item">
      <span class="c-icon-list__icon">
        <i class="icon icon--stopwatch"></i>
      </span>
        <span class="c-icon-list__content">List Item</span>
    </li>
    <li class="c-icon-list__item">
        <span class="c-icon-list__icon">
          <i class="icon icon--stopwatch"></i>
        </span>
        <span class="c-icon-list__content">List Item</span>
    </li>
</ul>
`,
  spaceAround: `<title class="c-title">Here is a list of what you'll need:</title>
  <ol class="c-ordered-list l-margin-vertical--large">
      <li class="c-ordered-list__item l-margin-left--medium">List Item</li>
      <li class="c-ordered-list__item l-margin-left--medium">List Item</li>
      <li class="c-ordered-list__item l-margin-left--medium">List Item</li>
  </ol> 
<p class="c-text-content">Now that you know what you'll need...</p>
`,
  spaceBetween: `<ul class="c-unordered-list l-margin-vertical--large">
      <li class="c-unordered-list__item l-margin-left--medium l-margin-bottom--medium">List Item</li>
      <li class="c-unordered-list__item l-margin-left--medium l-margin-bottom--medium">List Item</li>
      <li class="c-unordered-list__item l-margin-left--medium l-margin-bottom--medium">List Item</li>
  </ul> `,
}
